import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {AnalysisCard, CardDesc, CardTitle, Grid, SectionSubtitle, SectionTitle, Wrapper,} from './styles';
import {useLandingContext} from "../../../Landing";

export default function HowItWorks() {
    const {APP_DATA} = useLandingContext();

    return (
        <Wrapper>
            <SectionTitle>{APP_DATA.analysisTitle}</SectionTitle>
            <SectionSubtitle>{APP_DATA.analysisSubTitle}</SectionSubtitle>
            <Grid>
                {APP_DATA.analysisItems.map((item, index) => (
                    <AnalysisCard key={index}>
                        <CardTitle>
                            <CheckCircleIcon color="primary" sx={{fontSize: 16}}/>
                            {item.title}
                        </CardTitle>
                        <CardDesc>{item.desc}</CardDesc>
                    </AnalysisCard>
                ))}
            </Grid>
        </Wrapper>
    );
}
